import includes from 'lodash/includes';
import { CARE_ROLE } from '../../../constants/props';

export const isGuardianProxyPatent = role =>
  includes([CARE_ROLE.GUARDIAN, CARE_ROLE.PARENT, CARE_ROLE.PROXY], role);

export const isCaregiver = role => CARE_ROLE.CAREGIVER === role;



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/utils/checkUserRole.js